import styled from 'styled-components';

export const Button = styled.button`
  background-color: transparent;
  border: none;
  padding: 0px;
  cursor: pointer;
  line-height: 8px;
`;
